(function () {
  'use strict';

  var toggle  = document.getElementById('dk-toggle');
  var body    = document.getElementById('dk-body');
  var result  = document.getElementById('dk-result');
  var L       = window.DK_LABELS || {};
  var slugMap = L.slugMap || {};
  var answers = {};

  var productsRaw = [];
  try {
    productsRaw = JSON.parse(document.getElementById('dk-products-data').textContent);
  } catch (e) {}

  function toSlug(str) {
    if (!str) return '';
    var t = str.trim();
    return slugMap[t] || t;
  }

  function parseFamilie(str) {
    if (!str) return [];
    return str.split(',').map(function (s) { return toSlug(s); }).filter(Boolean);
  }

  function getSwatchColor(s) {
    if (!s) return '#999';
    return (L.stimmungColors || {})[s.toLowerCase().trim()] || '#999';
  }

  var charScale = ['trocken-klar', 'ausgewogen', 'weich-suess'];

  var moodGraph = {
    'frisch-leicht': ['sonnig-unbeschwert', 'ruhig-naturverbunden', 'elegant-fein'],
    'ruhig-naturverbunden': ['frisch-leicht', 'warm-geborgen'],
    'warm-geborgen': ['ruhig-naturverbunden', 'romantisch-weich', 'sinnlich-geheimnisvoll'],
    'sonnig-unbeschwert': ['frisch-leicht', 'romantisch-weich', 'elegant-fein'],
    'elegant-fein': ['frisch-leicht', 'sonnig-unbeschwert', 'romantisch-weich', 'sinnlich-geheimnisvoll', 'markant-besonders'],
    'romantisch-weich': ['warm-geborgen', 'sonnig-unbeschwert', 'elegant-fein', 'sinnlich-geheimnisvoll'],
    'sinnlich-geheimnisvoll': ['warm-geborgen', 'elegant-fein', 'romantisch-weich', 'markant-besonders'],
    'markant-besonders': ['elegant-fein', 'sinnlich-geheimnisvoll']
  };

  var moodFamilyAffinity = {
    'frisch-leicht': {
      'frisch-klar': 0, 'holzig-waldig': 0.2, 'blumig-elegant': 0.2,
      'fruchtig-saftig': 0.4, 'warm-wuerzig': 0.6, 'dunkel-sinnlich': 0.8
    },
    'ruhig-naturverbunden': {
      'holzig-waldig': 0, 'frisch-klar': 0.2, 'warm-wuerzig': 0.4,
      'blumig-elegant': 0.5, 'dunkel-sinnlich': 0.6, 'fruchtig-saftig': 0.7
    },
    'warm-geborgen': {
      'warm-wuerzig': 0, 'fruchtig-saftig': 0.2, 'dunkel-sinnlich': 0.3,
      'blumig-elegant': 0.4, 'holzig-waldig': 0.5, 'frisch-klar': 0.7
    },
    'sonnig-unbeschwert': {
      'fruchtig-saftig': 0, 'frisch-klar': 0, 'blumig-elegant': 0.2,
      'warm-wuerzig': 0.3, 'holzig-waldig': 0.6, 'dunkel-sinnlich': 0.7
    },
    'elegant-fein': {
      'blumig-elegant': 0, 'dunkel-sinnlich': 0.2, 'fruchtig-saftig': 0.4,
      'warm-wuerzig': 0.4, 'frisch-klar': 0.5, 'holzig-waldig': 0.6
    },
    'romantisch-weich': {
      'blumig-elegant': 0, 'fruchtig-saftig': 0.2, 'warm-wuerzig': 0.2,
      'dunkel-sinnlich': 0.4, 'frisch-klar': 0.5, 'holzig-waldig': 0.7
    },
    'sinnlich-geheimnisvoll': {
      'dunkel-sinnlich': 0, 'warm-wuerzig': 0.2, 'blumig-elegant': 0.2,
      'fruchtig-saftig': 0.4, 'holzig-waldig': 0.5, 'frisch-klar': 0.7
    },
    'markant-besonders': {
      'dunkel-sinnlich': 0, 'holzig-waldig': 0.2, 'warm-wuerzig': 0.2,
      'blumig-elegant': 0.4, 'frisch-klar': 0.6, 'fruchtig-saftig': 0.7
    }
  };

  function charakterDistance(metaVal, antwort) {
    var pIdx = charScale.indexOf(toSlug(metaVal));
    var aIdx = charScale.indexOf(antwort);
    if (pIdx === -1 || aIdx === -1) return 2;
    return Math.abs(pIdx - aIdx);
  }

  function moodDistance(from, to) {
    from = toSlug(from);
    to = toSlug(to);
    if (!from || !to) return 4;
    if (from === to) return 0;

    var queue = [{ key: from, d: 0 }];
    var seen = {};
    seen[from] = true;

    while (queue.length) {
      var current = queue.shift();
      var next = moodGraph[current.key] || [];
      for (var i = 0; i < next.length; i++) {
        if (next[i] === to) return current.d + 1;
        if (!seen[next[i]]) {
          seen[next[i]] = true;
          queue.push({ key: next[i], d: current.d + 1 });
        }
      }
    }
    return 4;
  }

  function familyPenalty(metaVal, antwort) {
    var fams = parseFamilie(metaVal);
    var idx = fams.indexOf(antwort);
    if (idx === -1) return null;
    return idx === 0 ? 0 : 1;
  }

  function secondaryMoodPenalty(metaVal, selectedFamily, selectedMood) {
    var fams = parseFamilie(metaVal);
    var others = fams.filter(function (f) { return f !== selectedFamily; });
    if (!others.length) return 0.35;

    var affinities = moodFamilyAffinity[selectedMood] || {};
    var best = 0.8;
    others.forEach(function (f) {
      if (typeof affinities[f] === 'number') best = Math.min(best, affinities[f]);
    });
    return best;
  }

  function scoreProduct(p, a1, a2, a3) {
    var fp = familyPenalty(p.df_familie, a1);
    if (fp === null) return -1;

    var distance =
      fp +
      charakterDistance(p.df_charakter, a2) * 2 +
      moodDistance(p.df_stimmung, a3) * 1.25 +
      secondaryMoodPenalty(p.df_familie, a1, a3);

    return 100 - distance * 10;
  }

  function tieBreak(p, a1, a2, a3) {
    var fams = parseFamilie(p.df_familie);
    var tb = 0;
    if (fams[0] === a1) tb += 100;
    if (toSlug(p.df_stimmung) === a3) tb += 10;
    if (toSlug(p.df_charakter) === a2) tb += 5;
    return tb;
  }

  function reasonText() {
    return 'Diese Komposition liegt deiner Auswahl insgesamt am nächsten.';
  }

  function formatNoten(n) {
    if (!n) return '';
    return n.split(/[,\/]/).map(function (s) { return s.trim(); }).join(' · ');
  }

  function altTag() {
    return 'Auch passend';
  }

  function renderMain(p, a1, a2, a3) {
    var color = getSwatchColor(p.stimmung);
    var meta  = [(p.stimmung || '').toUpperCase(), 'Empfehlung'].filter(Boolean).join(' · ');
    var img   = p.image ? '<a href="' + p.url + '"><img src="' + p.image + '" alt="' + p.title + '" loading="eager" fetchpriority="high"></a>' : '';
    var noten = formatNoten(p.duftnoten);
    return '<div class="dk-result-card-main">' +
      '<div class="dk-rc-image">' + img + '</div>' +
      '<div class="dk-rc-content">' +
        '<div class="dk-rc-meta"><span class="dk-rc-swatch" style="background:' + color + '"></span><span>' + meta + '</span></div>' +
        '<p class="dk-rc-name">' + p.title + '</p>' +
        (noten ? '<p class="dk-rc-noten">' + noten + '</p>' : '') +
        '<p class="dk-rc-reason">' + reasonText(a1, a2, a3) + '</p>' +
        '<div class="dk-rc-footer">' +
          (p.price ? '<span class="dk-rc-price">' + p.price + '\u202F€</span>' : '') +
          '<a class="dk-result-btn" href="' + p.url + '">Duft entdecken</a>' +
        '</div>' +
      '</div></div>';
  }



  function renderAlt(p, score) {
    var color = getSwatchColor(p.stimmung);
    var img   = p.image ? '<img src="' + p.image + '" alt="' + p.title + '" loading="lazy">' : '';
    var noten = formatNoten(p.duftnoten);
    return '<a class="dk-alt-card" href="' + p.url + '">' +
      '<div class="dk-alt-image">' + img + '</div>' +
      '<div class="dk-alt-body">' +
        '<div class="dk-alt-meta"><span class="dk-rc-swatch" style="background:' + color + '"></span>' +
        (p.stimmung ? '<span>' + p.stimmung.toUpperCase() + '</span>' : '') + '</div>' +
        '<div class="dk-alt-name">' + p.title + '</div>' +
        (noten ? '<div class="dk-alt-noten">' + noten + '</div>' : '') +
      '</div>' +
      '<div class="dk-alt-tag">' + altTag(score) + '</div></a>';
  }

  function showResult() {
    var a1 = answers[1], a2 = answers[2], a3 = answers[3];
    if (!a1 || !a2 || !a3) return;

    var scored = productsRaw
      .map(function (p, i) {
        return { p: p, score: scoreProduct(p, a1, a2, a3), tb: tieBreak(p, a1, a2, a3), idx: i };
      })
      .filter(function (x) { return x.score >= 0; });

    if (!scored.length) {
      document.getElementById('dk-result-main').innerHTML = '<p style="color:#888;font-size:0.9rem;">Kein passendes Produkt gefunden.</p>';
      document.getElementById('dk-result-alts').innerHTML = '';
      result.style.display = 'block';
      return;
    }

    scored.sort(function (a, b) {
      if (b.score !== a.score) return b.score - a.score;
      if (b.tb    !== a.tb)    return b.tb    - a.tb;
      return a.idx - b.idx;
    });

    document.getElementById('dk-result-main').innerHTML = renderMain(scored[0].p, a1, a2, a3);
    var h = '<p class="dk-alts-heading">Zwei weitere Empfehlungen</p>';
    if (scored[1]) h += renderAlt(scored[1].p, scored[1].score);
    if (scored[2]) h += renderAlt(scored[2].p, scored[2].score);
    document.getElementById('dk-result-alts').innerHTML = h;
    result.style.display = 'block';
  }

  document.querySelectorAll('.dk-answer').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var q = parseInt(this.dataset.q, 10);
      document.querySelectorAll('.dk-answer[data-q="' + q + '"]').forEach(function (b) {
        b.classList.remove('selected');
      });
      this.classList.add('selected');
      answers[q] = this.dataset.v;
      var next = document.getElementById('dk-step-' + (q + 1));
      if (next && next.style.display === 'none') next.style.display = 'block';
      if (answers[1] && answers[2] && answers[3]) showResult();
    });
  });



  // Kollektion in der Duftübersicht filtert die darunterliegenden Produkte,
  // ohne die Seite zu verlassen.
  var filterButtons = document.querySelectorAll('[data-dk-filter]');
  var filterItems = document.querySelectorAll('.dk-card, .dk-editorial');
  filterButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      var selected = this.dataset.dkFilter;
      filterButtons.forEach(function (item) {
        var active = item === button;
        item.classList.toggle('dk-world--active', active);
        item.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      filterItems.forEach(function (item) {
        var visible = selected === 'all' || (item.classList.contains('dk-card') && item.dataset.dkWorld === selected);
        item.hidden = !visible;
      });
    });
  });

  toggle.addEventListener('click', function () {
    var open = body.style.display === 'block';
    body.style.display = open ? 'none' : 'block';
    toggle.textContent = open ? 'Duftfinder starten' : 'Duftfinder schließen';
  });


  document.getElementById('dk-restart').addEventListener('click', function () {
    answers = {};
    document.querySelectorAll('.dk-answer').forEach(function (b) { b.classList.remove('selected'); });
    document.getElementById('dk-step-1').style.display = 'block';
    document.getElementById('dk-step-2').style.display = 'none';
    document.getElementById('dk-step-3').style.display = 'none';
    result.style.display = 'none';
    document.getElementById('dk-result-main').innerHTML = '';
    document.getElementById('dk-result-alts').innerHTML = '';
  });

  if (window.location.hash === '#duftfinder') {
    window.addEventListener('load', function () {
      var el = document.getElementById('duftfinder');
      if (el) { el.scrollIntoView({ behavior: 'smooth' }); body.style.display = 'block'; toggle.textContent = 'Duftfinder schließen'; }
    });
  }
})();
